module.exports = "https://web-assets.ifttt.com/packs/media/location_field/clear-bfc0d165.svg";